import { connect } from 'react-redux'

import { selectTimezoneOffset } from 'ducks/reports/controls'
import {
  messagesReceivedByHourOfWeekGauge,
  messagesReceivedByQuarterHourOfWeekGauge,
} from 'ducks/reports/gauges'

import { BusiestTimeVisualization } from 'ducks/reports/visualizations'

function selectProps(state, { timezone }) {
  const isTimezoneOffsetInteger = Number.isInteger(
    timezone || selectTimezoneOffset(state)
  )
  return {
    gauges: [
      isTimezoneOffsetInteger
        ? messagesReceivedByHourOfWeekGauge
        : messagesReceivedByQuarterHourOfWeekGauge,
    ],
    quarterHours: !isTimezoneOffsetInteger,
    timezoneOffset: timezone,
  }
}

export default connect(selectProps)(BusiestTimes)

function BusiestTimes(props) {
  return (
    <BusiestTimeVisualization
      {...props}
      measuring="messages received"
      measuringSingle="message received"
    />
  )
}
